// One source for both the address list and the map on the Contact page, so a
// branch cannot be corrected in one place and left stale in the other.
//
// `embedUrl` is optional. Without it the map is built from the address text,
// which Google geocodes on the fly -- good enough to land on the right block,
// but not pin-exact. To place the pin exactly, open the branch on Google Maps,
// choose Share > Embed a map, and paste the `src` of the <iframe> it gives you
// here as `embedUrl`.
export const BRANCHES = [
  {
    id: "main",
    label: "Main branch",
    address: "Plot no 6, Pocket 5, Sector 21, Rohini, New Delhi, Delhi 110086",
    // The main branch is a verified Google Business listing, so searching by
    // name lands the pin on the listing itself rather than on a geocoded
    // guess at the plot number.
    mapQuery:
      "A1 HOME TUTORS & A1 INSTITUTE & A1 PLAY SCHOOL, Plot no 6, Pocket 5, Sector 21, Rohini, New Delhi 110086",
    embedUrl: "",
  },
  {
    id: "second",
    label: "Second branch",
    address: "Plot no 138, Second floor, Pocket 5, Sector 21, Rohini, New Delhi, Delhi 110086",
    embedUrl: "",
  },
];

// The keyless `output=embed` form is deliberate: the Maps Embed API would need
// a browser-exposed API key, and this page only ever shows two fixed pins.
export const mapEmbedUrl = (branch) =>
  branch.embedUrl ||
  `https://maps.google.com/maps?q=${encodeURIComponent(
    branch.mapQuery || branch.address
  )}&z=16&output=embed`;

export const directionsUrl = (branch) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    branch.mapQuery || branch.address
  )}`;
